import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import MuiCard from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: "auto",
  },
  root: {
    borderRadius: 10,
    border: "1px solid transparent",
    // "&:hover": {
    //   color: "#3751FF",
    //   border: "1px solid #3751FF",
    // },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    width: "100%",
    "&:first-child": {
      marginTop: 0,
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  title: {},
}))

export default function Card({ action, actionText, children, title, ...props }) {
  const classes = useStyles()

  return (
    <MuiCard className={classes.root}>
      {title ? (
        <CardHeader className={classes.title} gutterBottom>
          {title}
        </CardHeader>
      ) : (
        ""
      )}
      <CardContent className={classes.content}>{children}</CardContent>
      {action ? (
        <CardActions>
          <Button className={classes.button} size="small" onClick={action}>
            {actionText || "Learn More"}
          </Button>
        </CardActions>
      ) : (
        ""
      )}
    </MuiCard>
  )
}
